export default __webpack_public_path__ + "static/media/logo.44ea0b9b.jpeg";